import { networkRequest, URLS } from "~src/api";
import { ConfigApiResponse } from "~src/redux/typings";

export const getConfig = async () => {
  return await networkRequest.get<ConfigApiResponse>(URLS.config);
};
